export default {
    ProductAuditStrategy: {
        top: {
          SKUreview: 'SKU信息审核',
          Create: '创建是否开启审核',
          Modify: '修改是否开启审核',
          Trigger: '触发审核条件',
          price: 'SKU价格变动',
          attribute: 'SKU属性变动',
        },
        middle: {
          synchronization: 'SKU信息同步',
          information: '同步商品信息到三方',
          classification: '同步商品分类到三方',
        },
        bottom: {
          shelf: '上下架审核',
          Open: '是否开启',
          select: '请选择一项触发审核条件',
          Whether: '是否保存当前操作?',
        }
    },
};
